import { ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

// Validate confirm password field 
export const confirmPasswordValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');
    
    return password.value !== confirmPassword.value ? { 'notMatching': true } : null;
};